"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorFromName = exports.errorFromCode = exports.NotImplementedError = exports.NumericalOverflowError = exports.InvalidDynamicRoyaltyError = exports.AccountNotFoundError = exports.UnknownAccountError = exports.MintStateLockedError = exports.InvalidLockedByError = exports.InvalidPolicyMintAssociationError = exports.InvalidPolicyEvaluationError = exports.InvalidPolicyCreationError = exports.InvalidAuthorityError = exports.InvalidTokenAccountError = exports.InvalidMetadataError = exports.InvalidMintError = void 0;
const createErrorFromCodeLookup = new Map();
const createErrorFromNameLookup = new Map();
/**
 * InvalidMint: 'Invalid mint'
 *
 * @category Errors
 * @category generated
 */
class InvalidMintError extends Error {
    constructor() {
        super('Invalid mint');
        this.code = 0x1770;
        this.name = 'InvalidMint';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidMintError);
        }
    }
}
exports.InvalidMintError = InvalidMintError;
createErrorFromCodeLookup.set(0x1770, () => new InvalidMintError());
createErrorFromNameLookup.set('InvalidMint', () => new InvalidMintError());
/**
 * InvalidMetadata: 'Invalid metadata'
 *
 * @category Errors
 * @category generated
 */
class InvalidMetadataError extends Error {
    constructor() {
        super('Invalid metadata');
        this.code = 0x1771;
        this.name = 'InvalidMetadata';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidMetadataError);
        }
    }
}
exports.InvalidMetadataError = InvalidMetadataError;
createErrorFromCodeLookup.set(0x1771, () => new InvalidMetadataError());
createErrorFromNameLookup.set('InvalidMetadata', () => new InvalidMetadataError());
/**
 * InvalidTokenAccount: 'Invalid token account'
 *
 * @category Errors
 * @category generated
 */
class InvalidTokenAccountError extends Error {
    constructor() {
        super('Invalid token account');
        this.code = 0x1772;
        this.name = 'InvalidTokenAccount';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidTokenAccountError);
        }
    }
}
exports.InvalidTokenAccountError = InvalidTokenAccountError;
createErrorFromCodeLookup.set(0x1772, () => new InvalidTokenAccountError());
createErrorFromNameLookup.set('InvalidTokenAccount', () => new InvalidTokenAccountError());
/**
 * InvalidAuthority: 'Invalid authority address'
 *
 * @category Errors
 * @category generated
 */
class InvalidAuthorityError extends Error {
    constructor() {
        super('Invalid authority address');
        this.code = 0x1773;
        this.name = 'InvalidAuthority';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidAuthorityError);
        }
    }
}
exports.InvalidAuthorityError = InvalidAuthorityError;
createErrorFromCodeLookup.set(0x1773, () => new InvalidAuthorityError());
createErrorFromNameLookup.set('InvalidAuthority', () => new InvalidAuthorityError());
/**
 * InvalidPolicyCreation: 'Invalid policy creation'
 *
 * @category Errors
 * @category generated
 */
class InvalidPolicyCreationError extends Error {
    constructor() {
        super('Invalid policy creation');
        this.code = 0x1774;
        this.name = 'InvalidPolicyCreation';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidPolicyCreationError);
        }
    }
}
exports.InvalidPolicyCreationError = InvalidPolicyCreationError;
createErrorFromCodeLookup.set(0x1774, () => new InvalidPolicyCreationError());
createErrorFromNameLookup.set('InvalidPolicyCreation', () => new InvalidPolicyCreationError());
/**
 * InvalidPolicyEvaluation: 'Invalid policy evaluation'
 *
 * @category Errors
 * @category generated
 */
class InvalidPolicyEvaluationError extends Error {
    constructor() {
        super('Invalid policy evaluation');
        this.code = 0x1775;
        this.name = 'InvalidPolicyEvaluation';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidPolicyEvaluationError);
        }
    }
}
exports.InvalidPolicyEvaluationError = InvalidPolicyEvaluationError;
createErrorFromCodeLookup.set(0x1775, () => new InvalidPolicyEvaluationError());
createErrorFromNameLookup.set('InvalidPolicyEvaluation', () => new InvalidPolicyEvaluationError());
/**
 * InvalidPolicyMintAssociation: 'Invalid policy mint association'
 *
 * @category Errors
 * @category generated
 */
class InvalidPolicyMintAssociationError extends Error {
    constructor() {
        super('Invalid policy mint association');
        this.code = 0x1776;
        this.name = 'InvalidPolicyMintAssociation';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidPolicyMintAssociationError);
        }
    }
}
exports.InvalidPolicyMintAssociationError = InvalidPolicyMintAssociationError;
createErrorFromCodeLookup.set(0x1776, () => new InvalidPolicyMintAssociationError());
createErrorFromNameLookup.set('InvalidPolicyMintAssociation', () => new InvalidPolicyMintAssociationError());
/**
 * InvalidLockedBy: 'Invalid locked by'
 *
 * @category Errors
 * @category generated
 */
class InvalidLockedByError extends Error {
    constructor() {
        super('Invalid locked by');
        this.code = 0x1777;
        this.name = 'InvalidLockedBy';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidLockedByError);
        }
    }
}
exports.InvalidLockedByError = InvalidLockedByError;
createErrorFromCodeLookup.set(0x1777, () => new InvalidLockedByError());
createErrorFromNameLookup.set('InvalidLockedBy', () => new InvalidLockedByError());
/**
 * MintStateLocked: 'Mint state is locked'
 *
 * @category Errors
 * @category generated
 */
class MintStateLockedError extends Error {
    constructor() {
        super('Mint state is locked');
        this.code = 0x1778;
        this.name = 'MintStateLocked';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, MintStateLockedError);
        }
    }
}
exports.MintStateLockedError = MintStateLockedError;
createErrorFromCodeLookup.set(0x1778, () => new MintStateLockedError());
createErrorFromNameLookup.set('MintStateLocked', () => new MintStateLockedError());
/**
 * UnknownAccount: 'Unknown account found in instruction'
 *
 * @category Errors
 * @category generated
 */
class UnknownAccountError extends Error {
    constructor() {
        super('Unknown account found in instruction');
        this.code = 0x1779;
        this.name = 'UnknownAccount';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, UnknownAccountError);
        }
    }
}
exports.UnknownAccountError = UnknownAccountError;
createErrorFromCodeLookup.set(0x1779, () => new UnknownAccountError());
createErrorFromNameLookup.set('UnknownAccount', () => new UnknownAccountError());
/**
 * AccountNotFound: 'Account not found in instruction'
 *
 * @category Errors
 * @category generated
 */
class AccountNotFoundError extends Error {
    constructor() {
        super('Account not found in instruction');
        this.code = 0x177a;
        this.name = 'AccountNotFound';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, AccountNotFoundError);
        }
    }
}
exports.AccountNotFoundError = AccountNotFoundError;
createErrorFromCodeLookup.set(0x177a, () => new AccountNotFoundError());
createErrorFromNameLookup.set('AccountNotFound', () => new AccountNotFoundError());
/**
 * InvalidDynamicRoyalty: 'Invalid dynamic royalty'
 *
 * @category Errors
 * @category generated
 */
class InvalidDynamicRoyaltyError extends Error {
    constructor() {
        super('Invalid dynamic royalty');
        this.code = 0x177b;
        this.name = 'InvalidDynamicRoyalty';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidDynamicRoyaltyError);
        }
    }
}
exports.InvalidDynamicRoyaltyError = InvalidDynamicRoyaltyError;
createErrorFromCodeLookup.set(0x177b, () => new InvalidDynamicRoyaltyError());
createErrorFromNameLookup.set('InvalidDynamicRoyalty', () => new InvalidDynamicRoyaltyError());
/**
 * NumericalOverflow: 'Numerical overflow'
 *
 * @category Errors
 * @category generated
 */
class NumericalOverflowError extends Error {
    constructor() {
        super('Numerical overflow');
        this.code = 0x177c;
        this.name = 'NumericalOverflow';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, NumericalOverflowError);
        }
    }
}
exports.NumericalOverflowError = NumericalOverflowError;
createErrorFromCodeLookup.set(0x177c, () => new NumericalOverflowError());
createErrorFromNameLookup.set('NumericalOverflow', () => new NumericalOverflowError());
/**
 * NotImplemented: 'Not Implemented'
 *
 * @category Errors
 * @category generated
 */
class NotImplementedError extends Error {
    constructor() {
        super('Not Implemented');
        this.code = 0x177d;
        this.name = 'NotImplemented';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, NotImplementedError);
        }
    }
}
exports.NotImplementedError = NotImplementedError;
createErrorFromCodeLookup.set(0x177d, () => new NotImplementedError());
createErrorFromNameLookup.set('NotImplemented', () => new NotImplementedError());
/**
 * Attempts to resolve a custom program error from the provided error code.
 * @category Errors
 * @category generated
 */
function errorFromCode(code) {
    const createError = createErrorFromCodeLookup.get(code);
    return createError != null ? createError() : null;
}
exports.errorFromCode = errorFromCode;
/**
 * Attempts to resolve a custom program error from the provided error name, i.e. 'Unauthorized'.
 * @category Errors
 * @category generated
 */
function errorFromName(name) {
    const createError = createErrorFromNameLookup.get(name);
    return createError != null ? createError() : null;
}
exports.errorFromName = errorFromName;
//# sourceMappingURL=data:application/json;base64,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